import getDay from 'utils/time/getDay';

export function isDuringWeekend(
  date: Date,
  sundayStart: boolean = false,
): boolean {
  const weekendDays = sundayStart ? [5, 6] : [6, 0]; // friday+saturday if sundayStart, saturday+sunday otherwise
  const dayOfWeek = getDay(date);
  return weekendDays.includes(dayOfWeek);
}
